function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var plugin = require('tailwindcss/plugin');

var merge = require('lodash.merge');

var castArray = require('lodash.castarray');

var styles = require('./styles');

var _require = require('./utils'),
    commonTrailingPseudos = _require.commonTrailingPseudos;

var computed = {// Reserved for future "magic properties", for example:
  // bulletColor: (color) => ({ 'ul > li::before': { backgroundColor: color } }),
};

function inWhere(selector, _ref) {
  var className = _ref.className,
      modifier = _ref.modifier,
      prefix = _ref.prefix;
  var prefixedNot = prefix(".not-".concat(className)).slice(1);
  var selectorPrefix = selector.startsWith('>') ? "".concat(modifier === 'DEFAULT' ? ".".concat(className) : ".".concat(className, "-").concat(modifier), " ") : ''; // Parse the selector, if every component ends in the same pseudo element(s) then move it to the end

  var _commonTrailingPseudo = commonTrailingPseudos(selector),
      _commonTrailingPseudo2 = _slicedToArray(_commonTrailingPseudo, 2),
      trailingPseudo = _commonTrailingPseudo2[0],
      rebuiltSelector = _commonTrailingPseudo2[1];

  if (trailingPseudo) {
    return ":where(".concat(selectorPrefix).concat(rebuiltSelector, "):not(:where([class~=\"").concat(prefixedNot, "\"] *))").concat(trailingPseudo);
  }

  return ":where(".concat(selectorPrefix).concat(selector, "):not(:where([class~=\"").concat(prefixedNot, "\"] *))");
}

function isObject(value) {
  return _typeof(value) === 'object' && value !== null;
}

function configToCss() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
      target = _ref2.target,
      className = _ref2.className,
      modifier = _ref2.modifier,
      prefix = _ref2.prefix;

  function updateSelector(k, v) {
    if (target === 'legacy') {
      return [k, v];
    }

    if (Array.isArray(v)) {
      return [k, v];
    }

    if (isObject(v)) {
      var nested = Object.values(v).some(isObject);

      if (nested) {
        return [inWhere(k, {
          className: className,
          modifier: modifier,
          prefix: prefix
        }), v, Object.fromEntries(Object.entries(v).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              k = _ref4[0],
              v = _ref4[1];

          return updateSelector(k, v);
        }))];
      }

      return [inWhere(k, {
        className: className,
        modifier: modifier,
        prefix: prefix
      }), v];
    }

    return [k, v];
  }

  return Object.fromEntries(Object.entries(merge.apply(void 0, [{}].concat(_toConsumableArray(Object.keys(config).filter(function (key) {
    return computed[key];
  }).map(function (key) {
    return computed[key](config[key]);
  })), _toConsumableArray(castArray(config.css || {}))))).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        k = _ref6[0],
        v = _ref6[1];

    return updateSelector(k, v);
  }));
}

module.exports = plugin.withOptions(function () {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$className = _ref7.className,
      className = _ref7$className === void 0 ? 'prose' : _ref7$className,
      _ref7$target = _ref7.target,
      target = _ref7$target === void 0 ? 'modern' : _ref7$target;

  return function (_ref8) {
    var addVariant = _ref8.addVariant,
        addComponents = _ref8.addComponents,
        theme = _ref8.theme,
        prefix = _ref8.prefix;
    var modifiers = theme('typography');
    var options = {
      className: className,
      prefix: prefix
    };

    for (var _i2 = 0, _arr2 = [['headings', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'th'], ['h1'], ['h2'], ['h3'], ['h4'], ['h5'], ['h6'], ['p'], ['a'], ['blockquote'], ['figure'], ['figcaption'], ['strong'], ['em'], ['code'], ['pre'], ['ol'], ['ul'], ['li'], ['table'], ['thead'], ['tr'], ['th'], ['td'], ['img'], ['video'], ['hr'], ['lead', '[class~="lead"]']]; _i2 < _arr2.length; _i2++) {
      var _arr2$_i = _toArray(_arr2[_i2]),
          name = _arr2$_i[0],
          selectors = _arr2$_i.slice(1);

      selectors = selectors.length === 0 ? [name] : selectors;
      var selector = target === 'legacy' ? selectors.map(function (selector) {
        return "& ".concat(selector);
      }) : selectors.join(', ');
      addVariant("".concat(className, "-").concat(name), target === 'legacy' ? selector : "& :is(".concat(inWhere(selector, options), ")"));
    }

    addComponents(Object.keys(modifiers).map(function (modifier) {
      return _defineProperty({}, modifier === 'DEFAULT' ? ".".concat(className) : ".".concat(className, "-").concat(modifier), configToCss(modifiers[modifier], {
        target: target,
        className: className,
        modifier: modifier,
        prefix: prefix
      }));
    }));
  };
}, function () {
  return {
    theme: {
      typography: styles
    }
  };
});